<template>
    <div>
        <b-card header-tag="header">
            <template #header>
                Student: &nbsp; <strong>{{examStudent.firstName}} {{examStudent.middleInitial}} {{examStudent.lastName}}</strong>
            </template>
            <b-card-text>
                <b-container>
                    <b-row>
                        <b-col sm="12" md="6" class="text-left">                                
                            District: <strong>{{examStudent.districtName}}</strong><br>
                            School: <strong>{{examStudent.schoolName}}</strong><br>
                            Teacher: <strong>{{examStudent.teacherName}}</strong><br>
                        </b-col>
                        <b-col sm="12" md="6" class="text-left">
                            Class: <strong>{{examStudent.className}}</strong><br>
                            Grade: <strong>{{examStudent.grade}}</strong>
                        </b-col>
                    </b-row>
                </b-container>
            </b-card-text>
            <div class="wronginfo mt-2">If this is not you, or you're assigned to the wrong exam, STOP and contact your teacher immediately.</div>
        </b-card>        
    </div>
</template>

<script>

export default {
    name: 'StudentInfo',
    props: {
        examStudent: Object
    }
}
</script>

<style scoped>
    .card-header {
        font-size: 130%;
        background-color: #D7D7D7;
    }
    .wronginfo {
        font-size: 0.75rem;
        font-weight: bold;
        color: red;
    }
</style>